export var PluginType;

(function (PluginType) {
  PluginType["EXTRACTOR"] = "extractor";
  PluginType["MUTATION"] = "mutation";
})(PluginType || (PluginType = {}));

export function isPlugin(plugin) {
  return !Boolean(plugin.plugin);
}
export function isPluginWithOptions(plugin) {
  return Boolean(plugin.plugin);
}